import '~ui/setup/lang';
import '~ui/setup/constructor-styles';

import React, {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {PromoApp} from '~ui/modules/app-promo';
import {WithRenderCallback} from '~ui/components/WithRenderCallback';

import {withAppProviders} from '~ui/hocs/with-app-providers';
import {initCounter} from '~ui/services/metrika';
import {rumSendBeforeFrameworkInit, rumSendFrameworkInited} from '~ui/utils/rum';

if (window.__DATA__.crossMetrikaId) {
    initCounter('Cross', window.__DATA__.crossMetrikaId);
}

rumSendBeforeFrameworkInit();

const Component = withAppProviders(PromoApp);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
    <WithRenderCallback callback={rumSendFrameworkInited}>
        <StrictMode>
            <Component />
        </StrictMode>
    </WithRenderCallback>,
);
